import { createStore } from 'vuex'
import api from '../api'

// 解码 JWT token（简单 base64 解码，不验证签名）
function decodeToken(token) {
  try {
    const parts = token.split('.')
    if (parts.length !== 3) return null
    const payload = parts[1]
    // base64url 转 base64
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/')
    // 解码
    const decoded = decodeURIComponent(atob(base64).split('').map(c => 
      '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    ).join(''))
    return JSON.parse(decoded)
  } catch (e) {
    console.error('Token decode error:', e)
    return null
  }
}

export default createStore({
  state: {
    token: localStorage.getItem('token') || null,
    userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
    isLoading: false
  },
  mutations: {
    setToken(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    },
    clearAuth(state) {
      state.token = null
      state.userInfo = {}
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
    },
    setLoading(state, isLoading) {
      state.isLoading = isLoading
    }
  },
  actions: {
    async login({ commit }, { username, password }) {
      try {
        const response = await api.login(username, password)
        commit('setToken', response.access_token)

        // 解码 token 获取用户信息
        const tokenData = decodeToken(response.access_token)
        const userInfo = {
          username: tokenData?.sub || username,
          user_id: tokenData?.user_id,
          is_admin: tokenData?.is_admin || false
        }
        commit('setUserInfo', userInfo)

        return { success: true }
      } catch (error) {
        return { success: false, message: error.response?.data?.detail || '登录失败' }
      }
    },
    logout({ commit }) {
      commit('clearAuth')
    }
  },
  getters: {
    isAuthenticated: state => !!state.token,
    isAdmin: state => state.userInfo.is_admin || false,
    currentUser: state => state.userInfo,
    isLoading: state => state.isLoading
  }
})
